import {
  createRouter,
  createWebHashHistory
} from 'vue-router'
/*
 **/
const routes = [{
  path: '/',
  name: 'Index',
  component: () => import( /* webpackChunkName: "Index" */ '../views/index/index.vue'),
  redirect: '/call-process',
  children: [{
    name: 'CallProcess',
    path: '/call-process',
    meta: {
      title: '呼叫处理'
    },
    component: () => import( /* webpackChunkName: "Index" */
      '../views/index/pages/call-process/index.vue')
  }, {
    name: 'LibrarySearch',
    path: '/library-search',
    meta: {
      title: '场库巡查'
    },
    component: () => import( /* webpackChunkName: "LibrarySearch" */
      '../views/index/pages/library-search/index.vue')
  }, {
    name: 'TaskOperation',
    path: '/task-operation',
    meta: {
      title: '任务操作'
    },
    component: () => import( /* webpackChunkName: "TaskOperation" */
      '../views/index/pages/task-operation/index.vue'),
    redirect: '/task-operation/update-abnormal-plate',
    children: [{
      name: 'UpdateAbnormalPlate',
      path: '/task-operation/update-abnormal-plate',
      meta: {
        title: '异常车牌修改'
      },
      component: () => import( /* webpackChunkName: "UpdateAbnormalPlate" */
        '../views/index/pages/task-operation/update-abnormal-plate.vue')
    }, {
      name: 'CloseChannel',
      path: '/task-operation/close-channel',
      meta: {
        title: '关闭通道'
      },
      component: () => import( /* webpackChunkName: "CloseChannel" */
        '../views/index/pages/task-operation/close-channel.vue')
    }, {
      name: 'SendSingle',
      path: '/task-operation/send-single',
      meta: {
        title: '派单'
      },
      component: () => import( /* webpackChunkName: "SendSingle" */
        '../views/index/pages/task-operation/send-single.vue')
    }, {
      name: 'RepairOrder',
      path: '/task-operation/repair-order',
      meta: {
        title: '工单'
      },
      component: () => import( /* webpackChunkName: "RepairOrder" */
        '../views/index/pages/task-operation/repair-order.vue')
    }, {
      name: 'BlackPlate',
      path: '/task-operation/black-plate',
      meta: {
        title: '车辆黑名单'
      },
      component: () => import( /* webpackChunkName: "BlackPlate" */
        '../views/index/pages/task-operation/black-plate.vue')
    }]
  }, {
    name: 'RecordsQuery',
    path: '/records-query',
    meta: {
      title: '记录查询'
    },
    component: () => import( /* webpackChunkName: "RecordsQuery" */
      '../views/index/pages/records-query/index.vue'),
    redirect: '/records-query/call-history',
    children: [{
      name: 'CallHistory',
      path: '/records-query/call-history',
      meta: {
        title: '呼叫记录'
      },
      component: () => import( /* webpackChunkName: "CallHistory" */
        '../views/index/pages/records-query/call-history.vue')
    }, {
      name: 'UpdateLicenseRecord',
      path: '/records-query/update-license-record',
      meta: {
        title: '车牌修改记录'
      },
      component: () => import( /* webpackChunkName: "UpdateLicenseRecord" */
        '../views/index/pages/records-query/update-license-record.vue')
    }, {
      name: 'CloseChannelRecord',
      path: '/records-query/close-channel-record',
      meta: {
        title: '关闭通道记录'
      },
      component: () => import( /* webpackChunkName: "CloseChannelRecord" */
        '../views/index/pages/records-query/close-channel-record.vue')
    }, {
      name: 'OperationRecord',
      path: '/records-query/operation-record',
      meta: {
        title: '操作记录'
      },
      component: () => import( /* webpackChunkName: "OperationRecord" */
        '../views/index/pages/records-query/operation-record.vue')
    }, {
      name: 'OnlineRecord',
      path: '/records-query/online-record',
      meta: {
        title: '设备在线状态'
      },
      component: () => import( /* webpackChunkName: "OnlineRecord" */
        '../views/index/pages/records-query/online-record.vue')
    }, {
      name: 'CallDuration',
      path: '/records-query/call-duration',
      meta: {
        title: '呼叫时长数据'
      },
      component: () => import( /* webpackChunkName: "CallDuration" */
        '../views/index/pages/records-query/call-duration.vue')
    }]
  }]
},
{
  path: '/login',
  name: 'Login',
  meta: {
    title: '用户登录'
  },
  component: () => import( /* webpackChunkName: "Index" */ '../views/login/index.vue')
}
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
